import Common from './Common';
import web from '../src/images/home_img.svg'

function Home() {
    return (
          <>
          <Common
                  tagLine="Front-End Web Developer"
                  imgSrc={web}
                  visit="/Service"
                  btnName="Get Started"
          />  
          </>
    );
  }
  
  export default Home;
  